import { useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { GreenroomState as GS } from '../../stores/types/types';
import logger from '../../utils/logger-rum';

interface ChromiumHTMLMediaElement extends HTMLMediaElement {
    setSinkId(sinkId: string): Promise<void>;
    sinkId: string; // a "default safe" device id (null if no sinkId is set)
}

export const useAudioSink = () => {
  const selectedOutput = useSelector((s: GS) => s.VideoReducer.selectedOutput);
  
  const applySinkId = useCallback(async (element: HTMLMediaElement | null) => {
    if (!element || !selectedOutput?.deviceId || selectedOutput.deviceId === 'default') {
      return;
    }

    // Skip if already set to the correct device
    if ((element as ChromiumHTMLMediaElement).sinkId === selectedOutput.deviceId) {
      return;
    }

    try {
      await (element as ChromiumHTMLMediaElement).setSinkId(selectedOutput.deviceId);
    } catch (error: any) {
      logger.error('Could not set audio output device:', selectedOutput?.deviceId, error.name, error.message);
    }
  }, [selectedOutput?.deviceId]);

  const sinkId = useMemo(() => {
    if (!selectedOutput?.deviceId || selectedOutput?.deviceId === 'default') {
        return null;
    }
    return selectedOutput.deviceId;
  }, [selectedOutput?.deviceId]);

  return { applySinkId, sinkId };
};

export default useAudioSink; 